import Vue from 'vue'
import Vuex from 'vuex'
import { getMenuList } from '@/api/menu'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: null,
    menuList: [],
    siteConfig: {
      showVisits: '1' // Default to show
    }
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setMenuList(state, menuList) {
      state.menuList = menuList
    },
    setSiteConfig(state, config) {
      state.siteConfig = { ...state.siteConfig, ...config }
    }
  },
  actions: {
    setUserInfo({ commit }, userInfo) {
      commit('setUserInfo', userInfo)
    },
    async fetchMenuList({ commit }) {
      try {
        const response = await getMenuList()
        const menuList = response.rows.map(item => {
          const isExternal = item.outlink && item.outlink.startsWith('http')
          const path = item.outlink ? item.outlink : `/menu/${item.id}`
          return {
            path,
            isExternal,
            menuName: item.name,
            id: item.id,
            scode: item.scode
          }
        })
        commit('setMenuList', menuList)
        return menuList
      } catch (error) {
        console.error('获取菜单列表失败:', error)
        return []
      }
    }
  },
  modules: {}
})
